import React from 'react';
import PortfolioRiskHeatmap from './PortfolioRiskHeatmap';

export default function Analytics({ roleMode, onGoToReports }) {
    return <PortfolioRiskHeatmap roleMode={roleMode} onGoToReports={onGoToReports} />;
}